import React, { useEffect, useRef } from 'react';
import { Box, Typography } from '@mui/material';

const SPOT_BY_RULE = {
    address_not_found: 'address',
    city_state_mismatch: 'address',
    duplicate_email: 'email',
    duplicate_phone: 'phone',
    miles_high: 'miles',
    miles_vs_history: 'miles',
    odometer_gap: 'odometer',
    duplicate_week: 'week',
    load_outside_week: 'loads',
    detention_time_order: 'detention',
    time_off_overlap: 'dates',
    time_off_long: 'dates',
    time_off_backdated: 'dates',
};

export function flagsForSpot(flags, spot) {
    return (flags || []).filter((flag) => SPOT_BY_RULE[flag.ruleCode] === spot);
}

export function primarySpot(flags) {
    for (const flag of flags || []) {
        const spot = SPOT_BY_RULE[flag.ruleCode];
        if (spot) return spot;
    }
    return '';
}

export function dateKey(value) {
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    return date.toISOString().slice(0, 10);
}

export function useFlagScroll(active) {
    const ref = useRef(null);
    useEffect(() => {
        if (!active) return undefined;
        const timer = window.setTimeout(() => {
            ref.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 450);
        return () => window.clearTimeout(timer);
    }, [active]);
    return ref;
}

const markSx = {
    borderRadius: 1,
    outline: '2px solid #ed6c02',
    outlineOffset: 3,
    backgroundColor: 'rgba(237, 108, 2, 0.12)',
    px: 1,
    py: 0.75,
    '@keyframes flagPulse': {
        '0%': { boxShadow: '0 0 0 0 rgba(237, 108, 2, 0.45)' },
        '100%': { boxShadow: '0 0 0 10px rgba(237, 108, 2, 0)' },
    },
    animation: 'flagPulse 1s ease-out 2',
};

export function FlagFocus({ spot, flags, scroll, sx, children }) {
    const matched = flagsForSpot(flags, spot);
    const ref = useFlagScroll(Boolean(scroll && matched.length));
    if (!matched.length) return children;
    return (
        <Box ref={ref} sx={{ ...markSx, ...sx }}>
            {matched.map((flag) => (
                <Typography key={flag._id || flag.ruleCode} variant="caption" sx={{ display: 'block', fontWeight: 700, color: '#ed6c02', mb: 0.5 }}>
                    {flag.message}
                </Typography>
            ))}
            {children}
        </Box>
    );
}
